export default {
  key:
    "hWA2C-7E2B2B1B3D4F2vd1EAJLQCVLUVBa1NXNRSSATEXD-13C3B2E2G2E3B1C2C7C2D1==",
  attribution: false,
};
